<template>
  <div>
    <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('multiSociety.list_society') }}</h3>
          </div>
          <div class="card-toolbar" >
            <Button btn-class="btn-sm" v-if="$can(abilities.CREATE_COMPANY)" type="new" btn-text="multiSociety.new_society" @click="openCreateModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_society" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th> {{$t("multiSociety.society_name")}}</th>
              <th> {{$t("multiSociety.country")}}</th>
              <th> {{$t("multiSociety.office_count")}}</th>
              <th>{{$t("actions")}}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>

    <CreateSocietyModal
        id="create_society"
        @reloadDatatable="reloadDatatable"
    />

    <UpdateSocietyModal
        id="update_society"
        :editForm="editForm"
        @reloadDatatable="reloadDatatable"
    />

    <UpdateSocietyLocateModal 
      id="set_society_location_modal"
      :editForm="editForm"
      @load="reloadDatatable"
    />
  </div>
</template>

<script setup>
  import {BASE_URL} from "@/services/api";
  import { useRouter } from "vue-router"
  import Ls from "@/services/ls";
  import { useI18n } from 'vue-i18n'
  import {useStore} from "vuex";
  import {nextTick, onMounted, ref, watch} from "vue"
  import {useHasAbility} from "@/composables/hasAbility";
  import { useLocales } from '@/composables/locales';
  import Button from "@/components/Button.vue"
  import {useSwal} from "@/composables/useSwal";
  import {Theme} from "@/composables/theming";
  import abilities from "@/composables/abilities";
  import CreateSocietyModal from "@/components/Office/CreateSocietyModal";
  import UpdateSocietyModal from "@/components/Office/UpdateSocietyModal";
  import UpdateSocietyLocateModal from "@/components/Office/UpdateSocietyLocateModal";

  const {showSwal} = useSwal()
  const { t } = useI18n({ useScope: 'global' })
  const { can } = useHasAbility()
  
  const table = ref(null)
  
  const {locale, datatableLocaleUrl} = useLocales()
  
  const editForm = ref({
    name: '',
    society_email: '',
    ifu_number: '',
    rccm_number: '',
    society_phone_code: '',
    society_phone: '',
    city: '',
    currency_id:'',
    country_id:'',
    zipcode: '',
    address: '',
    headquarters_address: '',
    legal_form: '',
    logo_url: null,
    online: true,
    image_url: null,
    id:"",
    longitude: '',
    latitude: '',
    timezone_id: ''
  })
  
  const router = useRouter()
  
  const store = useStore()
  
  onMounted(() => {
    fetchSocietyDatatable('kt_datatable_society')
  })

  watch(() => abilities, (value) => {
    nextTick(() =>  fetchSocietyDatatable('kt_datatable_society') )
  })
  
  watch(() => locale.value, () => {
    nextTick(() =>  fetchSocietyDatatable('kt_datatable_society') )
  })
  
  function openCreateModal(){
    $('#kt_modal_create_society').modal('toggle')
  }

  
  function fetchSocietyDatatable(tableId){
    const AUTH_TOKEN = Ls.get('auth.token')
    const pageLimit = Ls.get('pageLength')
    table.value = $("#" + tableId).DataTable({
      destroy: true,
      responsive: !0,
      searchDelay: 500,
      processing: !0,
      serverSide: !0,
      pageLength: pageLimit ||  5,
      lengthMenu: [5, 10, 25, 50, 75, 100 ],
      order: [[ 0, 'asc']],
      ajax: {
        url: BASE_URL + "/get/datatable/societies",
        type: "GET",
        beforeSend: function (request, options) {
          request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          request.setRequestHeader("Company", Ls.get('current.company'));
        }
      },
      columns: [{ data: "name" },{ data: "country_name" },{ data: "number_of_offices" }, { data: "Actions", responsivePriority: -1 }],
      columnDefs: [

        {
          targets: -4,
          order: "desc",
          render: function (t, a, e, l) {
            return '<span>' + t + "</span>";
          },
        },
        {
          targets: -3,
          order: "desc",
          render: function (t, a, e, l) {
            return '<span>' + t + "</span>";
          },
        },
        {
          targets: -2,
          order: "desc",
          render: function (t, a, e, l) {
            return '<span>' + t + "</span>";
          },
        },
        {
          width: "15%",
          targets: -1,
          "className": "dt-center",
          title: "Actions",
          orderable: !1,
          render: (t, a, e, l) => {
            let render=""
  
            if(can(abilities.UPDATE_COMPANY)) {
              render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" data-address="'+ e.address +'" data-currency="'+ e.currency_id +'" data-society="'+ e.society_id +'" data-phone-code="'+ e.phone_code +'"  data-phone="'+ e.phone +'" data-city="'+ e.city +'" data-zipcode="'+ e.zipcode +'"  data-legal_form="'+ e.legal_form +'"  data-headquarters_address="'+ e.headquarters_address +'"  data-country-id="'+ e.country_id +'"    data-email="'+ e.society_email +'" data-ifu="'+ e.ifu_number +'" data-rccm="'+ e.rccm_number +'" data-longitude="'+ e.longitude +'" data-latitude="'+ e.latitude +'" data-timezone="'+ e.timezone_id +'"  class="btn btn-sm btn-clean btn-icon edit_btn" ><i data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" data-address="'+ e.address +'" data-currency="'+ e.currency_id +'" data-society="'+ e.society_id +'" data-phone-code="'+ e.phone_code +'"  data-phone="'+ e.phone +'" data-city="'+ e.city +'" data-zipcode="'+ e.zipcode +'"  data-legal_form="'+ e.legal_form +'" data-headquarters_address="'+ e.headquarters_address +'"  data-country-id="'+ e.country_id +'"  data-email="'+ e.society_email +'"  data-ifu="'+ e.ifu_number +'" data-rccm="'+ e.rccm_number +'" data-longitude="'+ e.longitude +'" data-latitude="'+ e.latitude +'" data-timezone="'+ e.timezone_id +'" class="fas fa-edit fs-2" style="color: '+Theme.gray +'" data-toggle="tooltip" data-placement="top" title="'+i18n.global.t('button.edit')+'" ></i></a>'
              render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" data-address="'+ e.address +'" data-currency="'+ e.currency_id +'" data-society="'+ e.society_id +'" data-phone-code="'+ e.phone_code +'"  data-phone="'+ e.phone +'" data-city="'+ e.city +'" data-zipcode="'+ e.zipcode +'"  data-legal_form="'+ e.legal_form +'"  data-headquarters_address="'+ e.headquarters_address +'"  data-country-id="'+ e.country_id +'"    data-email="'+ e.society_email +'" data-ifu="'+ e.ifu_number +'" data-rccm="'+ e.rccm_number +'" data-longitude="'+ e.longitude +'" data-latitude="'+ e.latitude +'" data-timezone="'+ e.timezone_id +'"  class="btn btn-sm btn-clean btn-icon map_btn" ><i data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" data-address="'+ e.address +'" data-currency="'+ e.currency_id +'" data-society="'+ e.society_id +'" data-phone-code="'+ e.phone_code +'"  data-phone="'+ e.phone +'" data-city="'+ e.city +'" data-zipcode="'+ e.zipcode +'"  data-legal_form="'+ e.legal_form +'" data-headquarters_address="'+ e.headquarters_address +'"  data-country-id="'+ e.country_id +'"  data-email="'+ e.society_email +'"  data-ifu="'+ e.ifu_number +'" data-rccm="'+ e.rccm_number +'" data-longitude="'+ e.longitude +'" data-latitude="'+ e.latitude +'" data-timezone="'+ e.timezone_id +'" class="fas fa-map-marker-alt fs-2" style="color: '+Theme.gray +'" data-toggle="tooltip" data-placement="top" title="'+i18n.global.t('company.label.location')+'" ></i></a>'
            }

            return render
          },
        },
      ],
      language: {
        url:  datatableLocaleUrl.value
      }
    });
  
  }

  $(document).on("click", "#kt_datatable_society .edit_btn", (e) => {
    editForm.value.id = e.target.getAttribute('data-id')
    editForm.value.name = e.target.getAttribute('data-name')
    editForm.value.society_email = e.target.getAttribute('data-email')
    editForm.value.address = e.target.getAttribute('data-address')
    editForm.value.country_id = e.target.getAttribute('data-country-id')
    editForm.value.currency_id = e.target.getAttribute('data-currency')
    editForm.value.phone_code = e.target.getAttribute('data-phone-code')
    editForm.value.city = e.target.getAttribute('data-city')
    editForm.value.zipcode = e.target.getAttribute('data-zipcode')
    editForm.value.legal_form = e.target.getAttribute('data-legal_form')
    editForm.value.phone = e.target.getAttribute('data-phone')
    editForm.value.headquarters_address = e.target.getAttribute('data-headquarters_address')
    editForm.value.ifu_number = e.target.getAttribute('data-ifu')
    editForm.value.rccm_number = e.target.getAttribute('data-rccm')
    editForm.value.longitude = e.target.getAttribute('data-longitude')
    editForm.value.latitude = e.target.getAttribute('data-latitude')
    editForm.value.timezone_id = e.target.getAttribute('data-timezone')

    $('#kt_modal_update_society').modal('toggle')
  });

  $(document).on("click", "#kt_datatable_society .map_btn", (e) => {
    editForm.value.id = e.target.getAttribute('data-id')
    editForm.value.name = e.target.getAttribute('data-name')
    editForm.value.society_email = e.target.getAttribute('data-email')
    editForm.value.address = e.target.getAttribute('data-address')
    editForm.value.country_id = e.target.getAttribute('data-country-id')
    editForm.value.currency_id = e.target.getAttribute('data-currency')
    editForm.value.phone_code = e.target.getAttribute('data-phone-code')
    editForm.value.city = e.target.getAttribute('data-city')
    editForm.value.zipcode = e.target.getAttribute('data-zipcode')
    editForm.value.legal_form = e.target.getAttribute('data-legal_form')
    editForm.value.phone = e.target.getAttribute('data-phone')
    editForm.value.headquarters_address = e.target.getAttribute('data-headquarters_address')
    editForm.value.ifu_number = e.target.getAttribute('data-ifu')
    editForm.value.rccm_number = e.target.getAttribute('data-rccm')
    editForm.value.longitude = e.target.getAttribute('data-longitude')
    editForm.value.latitude = e.target.getAttribute('data-latitude')
    editForm.value.timezone_id = e.target.getAttribute('data-timezone')

    $('#set_society_location_modal').modal('toggle')
  });
  
  $(document).on("click", "#kt_datatable_society .users_btn", (e) => {
    router.push({
      name: 'settings-department-users',
      params: { id: e.target.getAttribute('data-id') }
    })
  });
  
  function reloadDatatable() {
    fetchSocietyDatatable('kt_datatable_society')
  }
  
  </script>
  